import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UILibModule } from '../uilib/uilib.module';
import { LocationsComponent } from './locations.component';

const routes = [
  { path: '', component: LocationsComponent }
];

@NgModule({
  declarations: [LocationsComponent],
  imports: [
    CommonModule,
    UILibModule,
    RouterModule.forChild(routes),
  ]
})
export class LocationsModule { }
